import { Component } from 'opus-angular-seed-core';

@Component({
    template: `
        <div class="col00">
            <div class="heading01 type01">
                <h1>{{ 'general.Support' | translate }}</h1>
            </div>
        </div>
    `
})
export default class {
}



// WEBPACK FOOTER //
// ./src/app/components/support/index.js